import { forEachObjIndexed } from 'ramda';

class FormManager {
  constructor(props) {
    this.forms = {};
    this.fieldForms = {};
  }

  setForm = (key, form) => {
    if (!this.forms[key]) {
      if (this.fieldForms[key]) {

        forEachObjIndexed(input => {
          form.subscribe(input);
        }, this.fieldForms[key]);

        this.fieldForms[key] = null;
      }
      this.forms[key] = form;
    }
  }

  destroyForm = (key) => {
    this.forms[key] = null;
  }

  addField = (key, model, subscription) => {
    if (this.forms[key]) {
      this.forms[key].subscribe(subscription);
    } else {
      this.fieldForms[key] = {
        ...(this.fieldForms[key] || {}),
        [model]: subscription
      };
    }
  }

  getForm = (key) => {
    if (this.forms[key]) {
      const form = this.forms[key];
      const state = form.state;

      return {
        validForm: state.validForm,
        requestInProgress: state.requestInProgress,
        subscribe: form.subscribe,
        validate: form.validate,
        onGlobalChange: form.onGlobalChange,
        onGlobalBlur: form.onGlobalBlur,
        onGlobalSubmit: form.onGlobalSubmit,
        onOverrideValues: form.onOverrideValues,
        updateModel: form.updateModel,
        inputList: state.inputList,
        overrideBaseValidations: form.overrideBaseValidations,
        getValidClass: form.getValidClass,
        manageLoading: form.manageLoading
      };
    }
  }

}

let contentGetInstance = null;
export default () => {
  return contentGetInstance ? contentGetInstance : (contentGetInstance = new FormManager());
}